/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validators_RequiredInputs */

const en_validators_required = /** @type {(inputs: Validators_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This field is required.`)
};

const de_validators_required = /** @type {(inputs: Validators_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Feld ist erforderlich.`)
};

/**
* | output |
* | --- |
* | "This field is required." |
*
* @param {Validators_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validators_required = /** @type {((inputs?: Validators_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validators_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validators_required(inputs)
	return de_validators_required(inputs)
});